<!-- Divider -->
<div
    class="treo-vertical-navigation-item-wrapper divider"
    [ngClass]="item.classes?.wrapper"></div>
